export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-1440x2560-10e05e615b37c596f1f964ef386ee5a7.jpg";